module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f423.3e830e73.svg";